import { CardHead } from './CardHead';
import './ChartCard.css';

export function ChartCard({ title, subtitle, actions, footer, children, className, onClick }) {
  const clickable = typeof onClick === 'function';
  const cls = ['ui-chart-card', clickable && 'ui-chart-card--clickable', className].filter(Boolean).join(' ');
  // Grafik içindeki etkileşimleri (hover/legend) bozmadan: tıklamayı sadece başlık/boşlukta yakala.
  const onHeadClick = clickable ? (e) => { e.stopPropagation(); onClick(e); } : undefined;
  return (
    <article className={cls}>
      <div
        className={clickable ? 'ui-chart-card-clickhead' : undefined}
        onClick={onHeadClick}
        role={clickable ? 'button' : undefined}
        tabIndex={clickable ? 0 : undefined}
        onKeyDown={clickable ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(e); } } : undefined}
        title={clickable ? 'Detayları gör' : undefined}
      >
        <CardHead title={title} subtitle={subtitle} actions={actions} />
      </div>
      <div className="ui-chart-card-body">{children}</div>
      {footer && <div className="ui-chart-card-foot">{footer}</div>}
    </article>
  );
}
